// extracted by mini-css-extract-plugin
export var chartContainer = "bX_hc";
export var errorContainer = "bX_hf";
export var errorMessage = "bX_hh";
export var errorTitle = "bX_hg";
export var footer = "bX_fF";
export var footerHighlight = "bX_hd";
export var wrapper = "bX_bF";